import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { Fragment } from "react";
import { Link } from "@zapier/design-system";
import { ButtonLink } from "@zapier/upsells/esm/components";
const views = {
    ["DEFAULT"]: () => ({
        bodyText: (_jsxs(Fragment, { children: ["To turn on your Zap, you'll need access to more", " ", _jsx(Link, { href: "/apps/categories/premium", target: "_blank", children: "premium apps" }), ". Edit your Zap or upgrade now to turn on your Zap."] })),
        type: "DEFAULT",
    }),
    ["TRIAL_EXTENSION"]: ({ onUpgradeClick, }) => ({
        bodyText: (_jsxs(Fragment, { children: ["To turn on your Zap, you'll need access to more", " ", _jsx(Link, { href: "/apps/categories/premium", target: "_blank", children: "premium apps" }), ". Upgrade now or start a free 7-day trial of the", " ", _jsx(ButtonLink, { onClick: onUpgradeClick, children: "Professional plan" }), " to use unlimited premium apps."] })),
        type: "TRIAL_EXTENSION",
    }),
};
export const getActiveView = ({ canExtendTrial, onUpgradeClick }) => canExtendTrial ? views.TRIAL_EXTENSION({ onUpgradeClick }) : views.DEFAULT();

// @zapier/upsells@8.0.1 (466b4077f)
